<template>
  <div class="col-lg-12">
    <div class="main-card mb-3 card">
      <div class="card-body">
        <h5 class="card-title">가맹설명회 신청자<div class="sub_title">신청관리 → 가맹설명회</div>
        </h5>
        <query-grid :config="config" ref="qg">
          <template #actions>

            <router-link to="/requests/franchise_meetings/plans"><button type="button" class="btn btn-info">일정으로
                돌아가기</button></router-link>
            <!--button class="btn btn-success ">엑셀저장</button-->
          </template>
          <template #items="props">
            <tr v-for="record in props.records" v-bind:key="record.id" :class="{'table-danger': record.deleted_at}">
              <td scope="col"><input type="checkbox" v-model="record.checked"></td>
              <td scope="row" style="text-align:center;">{{ record.id }}</td>

              <td style="text-align:center;">
                <!--a href="#" data-bs-toggle="modal" data-bs-target=".bd-example-modal-lg"
                  @click="moreStudentInfo(record)">{{ record.username }}</a-->
                {{ record.open_time }}
              </td>

              <td style="text-align:center;">
                {{ record.plan_name }}
              </td>
              <td style="text-align:center;">
                {{ record.name }}
              </td>
              <td style="text-align:center;">
                {{ record.phone_number }}
              </td>
              <td style="text-align:center;">
                <span v-if="record.operating_status == '1'">운영중</span>
                <span v-if="record.operating_status == '2'">오픈예정</span>
              </td>
               <td style="text-align:center;">
                {{ record.operating_name }}
              </td>
              <td style="text-align:center;">
                <span v-if="record.optarget_1 == 1">유치 </span>
                <span v-if="record.optarget_2 == 1">초등 </span>
                <span v-if="record.optarget_3 == 1">중등 </span>
                <span v-if="record.optarget_4 == 1">고등 </span>
                <span v-if="record.optarget_5 == 1">기타 </span>
              </td>
              <td style="text-align:center;">
                <span v-if="record.request_path == '1'">지인소개</span>
                <span v-if="record.request_path == '2'">인터넷 검색</span>
                <span v-if="record.request_path == '3'">유튜브</span>
                <span v-if="record.request_path == '4'">광고(배너)등</span>
                <span v-if="record.request_path == '5'">문자</span>
                <span v-if="record.request_path == '6'">기타</span>
              </td>
              <td style="text-align:center;">
                {{ record.request_region }}
              </td>
              <td style="text-align:center;">
                {{ record.req_ip }}
              </td>
              <td style="text-align:center;">
                {{ record.created_at }}
              </td>
              <td style="text-align:center;">
                {{ record.cancel_at }}
              </td>

              <td style="text-align:center;">
                
                <button class="btn btn-info btn-sm" style="padding:2px 4px; font-size:12px;"
                  @click="fetchDetail(record)" data-bs-toggle="modal" data-bs-target=".bd-attendants-modal-lg" >상세</button>
              </td>

            </tr>
          </template>

        </query-grid>

        <div class="modal fade bd-attendants-modal-lg" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">신청자 관리</h5>


              </div>
              <div class="modal-body">
                <i class="fas fa-check-circle"></i> 필수입력
                <table class="table">
                  <tbody>
                    <tr>
                      <td class="th_bg">이름</td>
                      <td>{{selRecord.name}}</td>
                      <td class="th_bg">신청번호</td>
                      <td>{{selRecord.id}}</td>
                    </tr>
                    <tr>
                      <td class="th_bg">운영상태</td>
                      <td>
                        <span v-if="selRecord.operating_status == '1'">운영중</span>
                        <span v-if="selRecord.operating_status == '2'">오픈예정</span>
                      </td>
                      <td class="th_bg">학원명</td>
                      <td>{{selRecord.operating_name}}</td>
                    </tr>
                    <tr>
                      <td class="th_bg">대상</td>
                      <td>
                        <span v-if="selRecord.optarget_1 == 1">유치 </span>
                  <span v-if="selRecord.optarget_2 == 1">초등 </span>
                  <span v-if="selRecord.optarget_3 == 1">중등 </span>
                  <span v-if="selRecord.optarget_4 == 1">고등 </span>
                  <span v-if="selRecord.optarget_5 == 1">기타 </span>
                      </td>
                      <td class="th_bg">희망지역</td>
                      <td>{{ selRecord.request_region }}</td>
                    </tr>
                     <tr>
                      <td class="th_bg">IP</td>
                      <td>
                        {{ selRecord.req_ip}}
                      </td>
                      <td class="th_bg">신청시간</td>
                      <td>{{ selRecord.created_at }}</td>
                    </tr>
                    <tr>
                      <td class="th_bg">연락처</td>
                      <td>
                        {{ selRecord.phone_number}}
                      </td>
                      <td class="th_bg">유입경로</td>
                      <td>
                        <span v-if="selRecord.request_path == '1'">지인소개</span>
                        <span v-if="selRecord.request_path == '2'">인터넷 검색</span>
                        <span v-if="selRecord.request_path == '3'">유튜브</span>
                        <span v-if="selRecord.request_path == '4'">광고(배너)등</span>
                        <span v-if="selRecord.request_path == '5'">문자</span>
                        <span v-if="selRecord.request_path == '6'">기타</span>
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">취소시간</td>
                      <td>{{ selRecord.cancel_at }}</td>
                      <td class="th_bg"></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>

                <table class="table">
                  <tbody>
                    <tr>
                      <td class="th_bg">회차 이름</td>
                      <td>{{selRecord.plan_name}}</td>
                      <td class="th_bg">진행시간</td>
                      <td>{{selRecord.open_time}}</td>
                    </tr>
                  </tbody>
                </table>

                                    <table class="table">
                      <tr>
                        <th colspan="4" style="height:50px;">
                          관리메모
                        </th>

                      </tr>
                      <tr v-for="memo in selRecord.memos" :key="memo.id">

                        <td style="width:50%; text-align:left;">
                          {{ memo.text }}
                        </td>
                        <td>
                          {{ memo.admin_name }}
                        </td>
                        <td>
                          {{ memo.created_at }}
                        </td>
                        <td>
                          <a @click="delMemo(memo)"><button class="btn btn-danger btn-sm">삭제</button></a>
                        </td>

                      </tr>
                    </table>
                    <table class="table">
                      <tr>
                        <th>
                          메모작성
                        </th>
                        <td style="height:60px;">
                          <input type="text" class="form-control" placeholder="여기에 메모를 작성 .."
                            v-model="this.selRecord.memo" />
                        </td>
                        <td style="text-align:right;">
                          <button class="btn btn-warning btn-block" @click="addMemo(selRecord)">작성</button>
                        </td>
                      </tr>

                    </table>

                
              </div>
              <div class="modal-footer flex_center">
                
                <button class="btn btn-danger" style="padding:2px 4px; font-size:12px;"  data-bs-dismiss="modal"
                  @click="markAsCancel(selRecord)" v-if="!selRecord.cancel_at">취소</button>
                <button class="btn btn-danger " style="padding:2px 4px; font-size:12px;"  data-bs-dismiss="modal"
                  @click="markAsDelete(selRecord)">삭제</button>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">닫기</button>

              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>


</template>

<script>
  // @ is an alias to /src

  import Admin from "../components/detail_pages/Admin";
  import QueryGrid from "../components/QueryGrid";
  import axios from "axios";
  export default {
    name: 'Home',
    components: {
      Admin,
      QueryGrid
    },
    mounted() {

      this.$refs.qg.pushSetting("status_filter_APPLIED", true);
      if (this.$route.params && this.$route.params.plan_id) {
        this.config.req_endpoint = `/requests/franchise_meetings/plans/${this.$route.params.plan_id}/attendants`
      } else {
        this.config.req_endpoint = "/requests/franchise_meetings/attendants"
      }
      this.$refs.qg.search();


    },
    methods: {
      fetchDetail(record){
        this.selRecord=record;
        console.log('load memo')
                axios.get('/requests/franchise_meetings/attendants/' + record.id + '/memos').then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '처리할 수 없습니다 ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.selRecord.memos = response.data.memos;
          }


        })

      },
            delMemo(memo) {
        axios.delete('/requests/franchise_meetings/attendants/' + this.selRecord.id  + '/memos/' + memo.id).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '삭제 실패하였습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            $.notify({
              // options
              message: '삭제 성공하였습니다. '
            }, {
              // settings
              type: 'success',
              z_index: 9999
            });
            this.fetchDetail(this.selRecord);

          }


        })
      },
      addMemo(record) {
        axios.post('/requests/franchise_meetings/attendants/' + record.id +  '/memos', {
          "memo": record.memo,
          "expiresAt": 0
        }).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '작성 실패하였습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            $.notify({
              // options
              message: '작성 성공하였습니다. '
            }, {
              // settings
              type: 'success',
              z_index: 9999
            });
            this.fetchDetail(record);

          }


        })
        this.record.memo = "";
      },
      markAsCancel(record) {
        var thhis = this;
        axios.patch('/requests/franchise_meetings/attendants/' + record.id, {
          status: 1
        }).then(function (response) {
          if (response.data.error) {
            $.notify({
              // options
              message: '처리할 수 없습니다 ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
            if (response.data.refresh_required) {
              thhis.$refs.qg.search()
            }
          } else {
            console.log(response.data.data);
            $.notify({
              // options
              message: '취소되었습니다.'
            }, {
              // settings
              type: 'success',
              z_index: 9999
            });
            thhis.$refs.qg.search()
          }


        })
      },
      markAsDelete(record) {
        var thhis = this;
        axios.delete('/requests/franchise_meetings/attendants/' + record.id).then(function (response) {
          if (response.data.error) {
            $.notify({
              // options
              message: '처리할 수 없습니다 ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
            if (response.data.refresh_required) {
              thhis.$refs.qg.search()
            }
          } else {
            console.log(response.data.data);
            $.notify({
              // options
              message: '삭제되었습니다.'
            }, {
              // settings
              type: 'success',
              z_index: 9999
            });
            thhis.$refs.qg.search()
          }


        })
      }
    },
    data() {
      return {
        config: {
          "name": "가맹설명회 참석자 리스트",
          "req_endpoint": "", // TBD
          "default_limit": 20,
          "search_fields": [{
              "id": "status_filter",
              "name": "상태",
              "type": "switch",
              "filter_type": {
                "APPLIED": "신청",
                "CANCELLED": "취소"
              }
            },
            {
              "id": "operating_status",
              "name": "운영여부",
              "type": "switch",
              "filter_type": {
                1: "운영중",
                2: "오픈예정"
              }
            },
            {
              "id": "operating_target",
              "name": "운영대상",
              "type": "switch",
              "filter_type": {
                1: "유치",
                2: "초등",
                3: "중등",
                4: "고등",
                5: "기타",
              }
            },
            {
              "id": "request_path",
              "name": "신청경로",
              "type": "switch",
              "filter_type": {
                1: "지인소개",
                2: "인터넷 검색",
                3: "유튜브",
                4: "광고(배너)등",
                5: "문자",
                6: "기타",
              }
            },
            {
              "id": "search",
              "name": "키워드검색",
              "type": "text",
              "placeholder": "신청자명/휴대폰번호/희망지역/IP/학원명"
            },
            {
              "id": "date_filter",
              "name": "날짜검색",
              "type": "date",
              "filter_type": {
                "open_time": "일정 날짜",
                "created_at": "신청 날짜",
                "cancel_at": "취소 날짜"
              }
            }
          ],
          "columns": [{
              "id": "chkbox",
              "name": "체크",
              "is_check": true
            },
            {
              "id": "id",
              "sortable": true,
              "name": "번호",
              "excel_print": v => {
                return v.id
              }
            },
            {
              "id": "open_time",
              "sortable": true,
              "name": "진행 날짜",
              "excel_print": v => {
                return v.open_time
              }
            },
            {
              "id": "name",
              "sortable": true,
              "name": "일정명",
              "excel_print": v => {
                return v.plan_name
              }
            },
            {
              "id": "name",
              "sortable": true,
              "name": "이름",
              "excel_print": v => {
                return v.name
              }
            },
            {
              "id": "phone_number",
              "sortable": true,
              "name": "전화번호",
              "excel_print": v => {
                return v.phone_number
              }
            },
            {
              "id": "operating_status",
              "sortable": true,
              "name": "운영여부",
              "excel_print": v => {
                var a = {
                  1: "운영중",
                  2: "오픈예정"
                };
                return a[v.operating_status]
              }
            },
            {
              "id": "operating_name",
              "sortable": true,
              "name": "학원명",
              "excel_print": v => {
                return v.operating_name
              }
            },
            {
              "id": "operating_target",
              "sortable": false,
              "name": "운영대상",
              "excel_print": v => {
                var mappings = ['0', '유치', '초등', '중등', '고등', '기타'];
                var res = [];
                for (let i = 1; i < 6; i++) {
                  if (v['optarget_' + i] == 1) {
                    res.push(mappings[i])
                  }
                }

                return res.join(" ");
              }
            },
            {
              "id": "request_path",
              "sortable": true,
              "name": "신청경로",
              "excel_print": v => {
                var a = {
                  1: "지인소개",
                  2: "인터넷 검색",
                  3: "유튜브",
                  4: "광고(배너)등",
                  5: "문자",
                  6: "기타",
                };
                return a[v.request_path]
              }
            },

            {
              "id": "request_region",
              "sortable": true,
              "name": "가맹희망지역",
              "excel_print": v => {
                return v.request_region
              }
            },

            {
              "id": "req_ip",
              "sortable": true,
              "name": "IP",
              "excel_print": v => {
                return v.req_ip
              }
            },
            {
              "id": "created_at",
              "sortable": true,
              "name": "신청일",
              "excel_print": v => {
                return v.created_at
              }
            },
            {
              "id": "cancel_at",
              "sortable": true,
              "name": "취소일",
              "excel_print": v => {
                return v.cancel_at
              }
            },
            {
              "id": "act",
              "name": "액션",
            }
          ],
          disable_init_search: true
        },
        selRecord: {
          "id": null,
          "open_time": null,
          "plan_name": null,
          "name": null,
          "phone_number": null,
          "operating_status": null,
          "optarget_1": null,
          "optarget_2": null,
          "optarget_3": null,
          "optarget_4": null,
          "optarget_5": null,
          "request_path": null,
          "request_region": null,
          "status": null,
          "req_ip": null,
          "created_at": null,
          "cancel_at": null,
          "memos": [

          ]

        },
        creating: true
      }
    }
  }
</script>